<template>
    <li class="relative">
        <button
            type="button"
            @click.prevent="addToProject"
            class="
                bg-gray-120
                dark:bg-gray-700
                border 
                border-keyline-primary 
                flex 
                gap-3 
                items-center 
                leading-none 
                max-w-full 
                p-3 
                rounded 
                text-left 
                w-full 
                at1440:p-4 
                hover:border-keyline-primary-invert  
            "
            
        >
            <span class="sr-only">Add to project</span>
            <span
                aria-hidden="true"
                :class="project.options.color ? 'bg-project-'+project.options.color : 'bg-project-lavender'"
                class="flex items-center justify-center rounded-md shrink-0 size-6"
            >
                <!-- The project name's first character. -->
                <span class="font-medium text-[12px] text-white uppercase">{{ project.initials }}</span>
              </span>
            <!-- Project name. -->
            <span class="leading-none mr-16 text-sm truncate">{{ project.label }}</span>
        </button>
        <!-- When an item is added to this project, add class `confirmation-run` -->
        <span ref="flashSpan" class="confirmation-ready" aria-hidden="true">
            <BaseSvg name="Check" aria-hidden="true" class="size-4"/>
            Added
        </span>
    </li>
</template>

<script setup>
import {ref} from "vue";
import {usePinsDrawer} from "@/Composables";
import { router } from '@inertiajs/vue3'

const flashSpan = ref(null);
const props = defineProps(['project']);

const { addItemToProject } = usePinsDrawer();

function addToProject() {
    let itemSlug = router.page.props.summary.slug;
    addItemToProject(props.project.uuid, itemSlug);

    flashSpan.value?.classList.add('confirmation-run');
    setTimeout(() => {
        flashSpan.value?.classList.remove('confirmation-run');
    }, 3000);
}
</script>
